import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-20" data-testid="payment-cancel-page">
      <div className="border-2 border-black bg-white p-8 md:p-10 text-center">
        <div className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-black/50 mb-3">
          <XCircle className="w-3.5 h-3.5" strokeWidth={2} /> Cancelled
        </div>
        <h1 className="font-serif font-black text-4xl tracking-tighter">
          No worries.<br /><span className="italic font-normal">Nothing was charged.</span>
        </h1>
        <p className="text-black/60 mt-4 text-sm">Come back whenever you&rsquo;re ready.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/pricing" className="bg-black text-white px-6 py-3 font-bold uppercase tracking-widest text-xs hover:bg-[#E63946]" data-testid="cancel-back-pricing">
            Back to pricing
          </Link>
          <Link to="/" className="border border-black px-6 py-3 font-bold uppercase tracking-widest text-xs hover:bg-black hover:text-white">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
